/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons";
import { colors } from "../../../constants/colors";

/* Styles */
import styles from "./styles.js";

const Footer = (props) => {
  const { setShowModal, handleSaveModal, btnSpinner, disableSubmit, confirmOnly, cancelText, confirmText } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <ContainerFluid className="gx-0">
      <Row>
        {!confirmOnly && (
          <Col className={classes.cancelBtnCol}>
            <UCButton
              onClick={() => setShowModal(false)}
              type="default"
              className={classes.cancelBtn}
              text={cancelText ?? <FormattedMessage id="confirm.action.modal.cancel" />}
            />
          </Col>
        )}
        <Col className={classes.saveBtnCol}>
          <UCButton
            className={classes.saveBtn}
            onClick={handleSaveModal}
            type="primary"
            text={confirmText ?? <FormattedMessage id="confirm.action.modal.confirm" />}
            dataTestId="confirmActionSubmit"
            disabled={ disableSubmit }
            spinner={{
              name: btnSpinner,
              size: 20,
              color: colors.white,
            }}
          />
        </Col>
      </Row>
    </ContainerFluid>
  );
};

export default Footer;